import React, { PropsWithChildren } from "react";
//#region types
import { FileUploaderProps } from "models/propTypes/fileUploaderPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region compnents
import { Grid } from "@mui/material";
import Icon from "../../../icon";
import FileUploaderErrors from "./fileUploaderErrors";
import FilesGridContainer from "./filesGridContainer";
//#endregion
//#region helpers
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const FileUploader: React.FC<PropsWithChildren<FileUploaderProps>> = (props) => {
  const {
    dragging,
    remainingFiles,
    disabled,
    readonly,
    invalidFileType,
    invalidFileSize,
    hasEmptyFile,
    beyondMaxAmountOfFiles,
    maxFileSize,
    allowedMaxFileCount,
    files,
    fileTypes,
    hideFileTypes,
    onSelectFileClick,
    onDrag,
    onDragStart,
    onDragEnd,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop,
    handleClose,
    onStopReading,
    onTileClick,
  } = props;

  const hasErrors = beyondMaxAmountOfFiles || invalidFileType || invalidFileSize || hasEmptyFile;

  return (
    <Grid container className={cssExports.fileUploaderRoot}>
      <Grid container spacing={2} direction="row">
        {!readonly ? (
          <Grid item container={files?.length === 0 && remainingFiles.length === 0}>
            <Grid
              item
              container={files?.length === 0 && remainingFiles.length === 0}
              className={clsx(
                cssExports.fileUploader,
                dragging ? cssExports.fileUploaderDragging : "",
                disabled ? cssExports.fileUploaderDisabled : "",
                hasErrors ? cssExports.fileUploaderError : ""
              )}
              onDrag={onDrag}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
              onDragOver={onDragOver}
              onDragEnter={onDragEnter}
              onDragLeave={onDragLeave}
              onDrop={onDrop}
              onClick={onSelectFileClick}
            >
              <Grid item container direction="row">
                <Grid item>
                  <Grid item className={cssExports.fileUploaderInput}>
                    <Icon icon={IconDefinitionConstants.WPlus} />
                  </Grid>
                </Grid>

                {files?.length === 0 && remainingFiles.length === 0 && (
                  <Grid
                    item
                    container
                    xs
                    direction="column"
                    justifyContent={hideFileTypes && !hasErrors ? "center" : "flex-start"}
                    className={cssExports.fileUploaderInputTextContainer}
                  >
                    <Grid
                      item
                      className={cssExports.fileUploaderText}
                      container
                      direction="column"
                      alignItems="flex-start"
                      justifyContent={hasErrors ? "flex-start" : "center"}
                    >
                      <Grid item className={cssExports.fileUploaderTextBrowse}>
                        <span>{`${LocalizationHelperInstance.getFormattedMessage(
                          TranslationKeys.Common.DropFileOrClickMessage
                        )} `}</span>
                        <span className={cssExports.link}>
                          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.BrowseMessage)}
                        </span>
                      </Grid>
                      {!hideFileTypes && (
                        <Grid item className={cssExports.fileUploaderSubText}>
                          {`${LocalizationHelperInstance.getFormattedMessage(
                            TranslationKeys.Common.FileFormatsMessage
                          )} ${fileTypes}`}
                        </Grid>
                      )}
                    </Grid>
                    {hasErrors && (
                      <>
                        <Grid item className={cssExports.errorMessageContainer}>
                          <FileUploaderErrors
                            invalidFileType={invalidFileType}
                            invalidFileSize={invalidFileSize}
                            hasEmptyFile={hasEmptyFile}
                            beyondMaxAmountOfFiles={beyondMaxAmountOfFiles}
                            maxFileSize={maxFileSize}
                            allowedMaxFileCount={allowedMaxFileCount}
                          ></FileUploaderErrors>
                        </Grid>

                        <Grid item className={cssExports.fileUploaderErrorIcon}>
                          !
                        </Grid>
                      </>
                    )}
                  </Grid>
                )}
              </Grid>
              {props.children}
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
        {((files != null && files.length > 0) || remainingFiles.length > 0) && (
          <Grid item container xs alignItems="flex-start" className={cssExports.fileUploaderFileContainer}>
            <FilesGridContainer
              files={files}
              remainingFiles={remainingFiles}
              onStopReading={onStopReading}
              handleClose={handleClose}
              readonly={props.readonly}
              onTileClick={onTileClick}
            ></FilesGridContainer>
            {hasErrors && (
              <FileUploaderErrors
                invalidFileType={invalidFileType}
                invalidFileSize={invalidFileSize}
                hasEmptyFile={hasEmptyFile}
                beyondMaxAmountOfFiles={beyondMaxAmountOfFiles}
                uploadedOnlyMax={beyondMaxAmountOfFiles && !dragging}
                maxFileSize={maxFileSize}
                allowedMaxFileCount={allowedMaxFileCount}
              ></FileUploaderErrors>
            )}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default FileUploader;
